import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TarefasProtocoloService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/protocolo-arquivo-agente';
  }

  public cancelarProtocolosEmValidacao(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/cancelar-protocolos-em-validacao`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
}
